import React, { useState } from 'react';
import ProposalsList from './ProposalsList';
import ProposalEditor from './ProposalEditor';

const PricingManager = () => {
  const [selectedProposalId, setSelectedProposalId] = useState(null);

  if (selectedProposalId) {
    return (
      <ProposalEditor
        proposalId={selectedProposalId}
        onBack={() => setSelectedProposalId(null)}
      />
    );
  }

  return (
    <ProposalsList onSelect={setSelectedProposalId} />
  );
};

export default PricingManager;
